import { render, staticRenderFns } from "./ServiciosSeur.vue?vue&type=template&id=033ca1b4&scoped=true"
import script from "./ServiciosSeur.vue?vue&type=script&lang=js"
export * from "./ServiciosSeur.vue?vue&type=script&lang=js"
import style0 from "./ServiciosSeur.vue?vue&type=style&index=0&id=033ca1b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ca1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('033ca1b4')) {
      api.createRecord('033ca1b4', component.options)
    } else {
      api.reload('033ca1b4', component.options)
    }
    module.hot.accept("./ServiciosSeur.vue?vue&type=template&id=033ca1b4&scoped=true", function () {
      api.rerender('033ca1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/ServiciosSeur/ServiciosSeur.vue"
export default component.exports